import yn from "yn";

const { VITE_DATASET_PREVIEW_MODE_ENABLED } = import.meta.env;

/**
 * Hook to check if Preview Mode is enabled.
 *
 * Preview Mode introduces a new access level for datasets that allows users
 * to see metadata and specifically allocated data, but not the full underlying
 * table data. This powers the preview access sharing functionality.
 *
 * When enabled, datasets can be shared with "preview" access, allowing
 * controlled visibility into dataset structure without exposing raw data.
 *
 * @returns boolean indicating if preview mode feature is enabled
 */
export const usePreviewMode = (): boolean => {
  return yn(VITE_DATASET_PREVIEW_MODE_ENABLED, { default: false });
};

export default usePreviewMode;
